var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.42 63.81",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#878cac;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.75,
    y: 18.73,
    width: 47.16,
    height: 10.72,
    transform: "translate(-5.22 35.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.92,
    y: -0.45,
    width: 3.18,
    height: 10.72,
    transform: "translate(13.96 43.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.92 46.46 25.55 45.49 18.98 38.92 17.92 46.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54,21.86A26.38,26.38,0,1,1,42.76,10.22l2.93-2.93A30.39,30.39,0,1,0,57,18.9Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NC40MiA2My44MSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4NzhjYWM7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5FZGl0PC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTYuNzUiIHk9IjE4LjczIiB3aWR0aD0iNDcuMTYiIGhlaWdodD0iMTAuNzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01LjIyIDM1LjU4KSByb3RhdGUoLTQ1KSIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iNTcuOTIiIHk9Ii0wLjQ1IiB3aWR0aD0iMy4xOCIgaGVpZ2h0PSIxMC43MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuOTYgNDMuNTIpIHJvdGF0ZSgtNDUpIi8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjE3LjkyIDQ2LjQ2IDI1LjU1IDQ1LjQ5IDE4Ljk4IDM4LjkyIDE3LjkyIDQ2LjQ2Ii8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTQsMjEuODZBMjYuMzgsMjYuMzgsMCwxLDEsNDIuNzYsMTAuMjJsMi45My0yLjkzQTMwLjM5LDMwLjM5LDAsMSwwLDU3LDE4LjlaIi8+PC9nPjwvZz48L3N2Zz4=";